const initialState = {
    chooser_open: false,
    loading: false,
    tariffs_loading: false,
    tariffs: null,
};
export function tariff_reducer(state = initialState, action) {
    switch (action.type) {
        case 'CHANGE_TARIFF__REQUEST':
            return { ...state, loading: true };
        case 'CHANGE_TARIFF__OK':
            return { ...state, chooser_open: false, loading: false };
        case 'CHANGE_TARIFF__FAIL':
            return { ...state, loading: false };
        case 'LOAD_TARIFFS__REQUEST':
            return { ...state, tariffs_loading: true };
        case 'LOAD_TARIFFS__FAIL':
            return { ...state, tariffs_loading: false };
        case 'LOAD_TARIFFS__OK':
            return { ...state, tariffs_loading: false, tariffs: action.tariffs };
        default:
            return state;
    }
}
